export const roundCallString = `{
  uuid,
  guid,
  screen_id,
  group_id,
  gpsi_car_number,
  gpsi_car_id,
  mdn,
  imei,
  elapsed_time,
  holes_completed,
  nine_hole_factor,
  course_launch_intent_mode,
  gpsi_server,
  gpsi_course_site_id,
  consumer_purchases,
  billable,
  end_time,
  start_time,
  error,
  success
}`;

export const sessionCallString = `{
  uuid,
  screen_id,
  group_id,
  ra_number
  expected_end_at,
  trip_type,
  end_at,
  start_at,
  error,
  success
}`;

export const analyticCallString = `{
  type
  screen_id,
  duration,
  description,
  round_id,
  end_time
}`;

export const uniqueRentalCallString = `{
  uuid,
  start_time,
  end_time,
  course_launch_intent_mode,
  consumer_purchases,
}`;

export const filterParams = ['trip_type', 'group_id', 'area_id'];

export const sharkScreensCallString = `{
  uuid
  ad_schedule
  beep
  charged_off
  area_id
  group_id
  store_id
  debug
  device_id
  notify_users
  phone_number
  launch_mode
  screen_uptime
  session_status
  launch_mode
  status
  version
  trip_type
  session_type
  checked
  pushy_token
  twilio
  last_activity
  error
  success
  imei
  mdn
  gpsi_car_number
  gpsi_car_id
  car_number
  group_name
  total,
  network_status,
  active_in_round,
}`;

export const sharkScreensChartCallString = `{
  screensLaunchCharts{
    chart{
      chartType,
      showOnMobile,
      type,
      component,
      width,
      title,
      data{ data },
      labels,
    }
  }
}`;
